export default __webpack_public_path__ + "assets/webgl/picking-10.41508224.glb";